module.exports = __webpack_public_path__ + "static/img/图层 504.8c670fcd.png";